/* src/app/ships/ship-merchants/ship-merchants.component.css */
input.ng-invalid.ng-touched {
  border: 1px solid red;
}
span.has-error {
  display: block;
}
a.transactionHistText:hover {
  text-decoration: underline;
  color: #337ab7;
}
/*# sourceMappingURL=ship-merchants.component.css.map */
